import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - données considérées fraîches
      refetchOnWindowFocus: false, // Ne pas refetch quand on revient sur l'onglet
      retry: 1, // Retry une seule fois en cas d'erreur
    },
    mutations: {
      retry: 1, // Retry une seule fois pour les mutations
    },
  },
});
